<div class="warning" *ngIf="(bookmark$ | async) && shown">

    <app-message-toggle
        type="warning"
        toggleStyle="flat"
        icon="info-circle"
        [dismiss]="true"
        (handleDismiss)="handleDismiss()">

        <div>
            This model is not optimized for use on mobile devices. For an optimal experience, please switch to a desktop device or try our Anatomy by Regions.
        </div>

    </app-message-toggle>

</div>